import React from 'react';
import {
  DataLayerHeader,
  DataLayerMobile,
  DataLayerMobileContent
} from '../../components/DataLayerMobile';
import { Column, Row } from '../../components/Grid';
import { HtmlContent } from '../../components/layout/HtmlContent';
import { Section } from '../../components/Section';
import { LayerContent } from '../../provider/Typo3Provider/types';

interface DataLayerContainerProps {
  layer: LayerContent;
  show: boolean;
}

const DataLayerContainerMobile = ({ layer, show }: DataLayerContainerProps) => {
  const { left, middle } = layer;

  return (
    <DataLayerMobile show={show}>
      <Section>
        <Row noGap>
          <Column>
            <DataLayerHeader>
              {left && <HtmlContent htmlString={left.header || ''} />}
            </DataLayerHeader>
          </Column>
        </Row>
        <Row noGap>
          <Column small={12}>
            <DataLayerMobileContent>
              {left && <HtmlContent htmlString={left.bodytext || ''} />}
            </DataLayerMobileContent>
          </Column>
          <Column small={12}>
            <DataLayerMobileContent>
              {middle && <HtmlContent htmlString={middle.bodytext || ''} />}
            </DataLayerMobileContent>
          </Column>
        </Row>
      </Section>
    </DataLayerMobile>
  );
};

export default DataLayerContainerMobile;
